import {gsap} from "gsap/all";

// Scrollbar shown beside the experts' list so players see it can be scrolled.
// It only displays the position: it follows the list's scroll event, which
// fires for touch dragging (Draggable), its inertia and the mouse wheel alike,
// and it can't be touched itself (pointer-events: none in the CSS).
export class ScrollIndicator {

  static MIN_THUMB_HEIGHT = 80;

  constructor($listing, $track) {
    this.listing = $listing[0];
    this.$track = $track;
    this.$thumb = $track.find(".scroll-indicator-thumb");

    $listing.on("scroll", () => this.update());

    // Sizes are only known once the screen is shown, and the list's height can
    // change as the card images load
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this.listing);
    if (this.listing.firstElementChild) this.observer.observe(this.listing.firstElementChild);

    this.update();
  }

  update() {
    const trackHeight = this.$track[0].offsetHeight;
    const {scrollHeight, clientHeight, scrollTop} = this.listing;
    if (!trackHeight || !scrollHeight) return; // hidden / not laid out yet

    // Thumb is as tall, relative to the track, as the visible part of the list
    const thumbHeight = Math.max(ScrollIndicator.MIN_THUMB_HEIGHT, trackHeight * clientHeight / scrollHeight);
    const maxScroll = scrollHeight - clientHeight;
    const progress = maxScroll > 0 ? gsap.utils.clamp(0, 1, scrollTop / maxScroll) : 0;

    gsap.set(this.$thumb, {
      height: thumbHeight,
      y: progress * (trackHeight - thumbHeight)
    });
  }
}
